import React from 'react';
import type { PeopleTravelOption, PeopleTravelTrip } from '../../../types';
import './PeopleTravel.css';

type Props = {
  trip: PeopleTravelTrip;
  options: PeopleTravelOption[];
};

const PeopleTravelBudgetPanel: React.FC<Props> = ({ trip, options }) => {
  const selected = options.filter(o => o.isSelected);
  const bestPicks: PeopleTravelOption[] = [];
  const bestByKind = new Map<string, PeopleTravelOption>();
  for (const opt of options) {
    const cur = bestByKind.get(opt.kind);
    if (!cur || (opt.rank ?? 999) < (cur.rank ?? 999)) bestByKind.set(opt.kind, opt);
  }
  bestByKind.forEach(opt => bestPicks.push(opt));

  return (
    <div>
      <h3 className="people-hub-panel-title">Budget</h3>
      <div className="people-hub-benefit-cards">
        <div className="people-hub-benefit-card">
          <div className="people-hub-benefit-label">Selected total</div>
          <div className="people-hub-benefit-value">
            ${trip.budget.selectedTotal.toLocaleString()}
          </div>
        </div>
        <div className="people-hub-benefit-card">
          <div className="people-hub-benefit-label">Agent estimate (best per category)</div>
          <div className="people-hub-benefit-value">
            ${trip.budget.estimatedTotal.toLocaleString()}
          </div>
        </div>
        <div className="people-hub-benefit-card">
          <div className="people-hub-benefit-label">Budget cap</div>
          <div className="people-hub-benefit-value">
            {trip.budget.cap != null ? `$${trip.budget.cap.toLocaleString()}` : '—'}
          </div>
        </div>
      </div>

      {trip.budget.cap != null && trip.budget.selectedTotal > trip.budget.cap && (
        <p className="people-travel-modal-error" style={{ marginTop: 12 }}>
          Selected total exceeds budget cap by $
          {(trip.budget.selectedTotal - trip.budget.cap).toLocaleString()}.
        </p>
      )}

      <h4 className="people-hub-panel-title people-hub-panel-title-spaced">Selected line items</h4>
      {selected.length === 0 ? (
        <p className="people-hub-muted">Select flight, hotel, and car options to build your budget.</p>
      ) : (
        <ul>
          {selected.map(opt => (
            <li key={opt.id}>
              {opt.label} — ${opt.price.toLocaleString()}
            </li>
          ))}
        </ul>
      )}

      <h4 className="people-hub-panel-title people-hub-panel-title-spaced">Best agent picks</h4>
      {bestPicks.length === 0 ? (
        <p className="people-hub-muted">Run travel agent search to see ranked estimates.</p>
      ) : (
        <ul>
          {bestPicks.map(opt => (
            <li key={opt.id}>
              {opt.kind}: {opt.label} — ${opt.price.toLocaleString()}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PeopleTravelBudgetPanel;
